import classNames from "classnames";
import Barcode from "react-barcode";

export default function OrderBarcode({
  value,
  className,
}: {
  value?: string;
  className?: string;
}) {
  if (!value) {
    return (
      <div
        className={classNames(
          "text-center text-gray-400 text-xs py-2",
          className,
        )}
      >
        No barcode available
      </div>
    );
  }

  return (
    <div className={classNames("flex justify-center mt-[-8px]", className)}>
      <Barcode value={value} height={40} displayValue fontSize={12} />
    </div>
  );
}
